import Raven from 'raven-js';
import { Provider } from 'react-redux';
import { DataFetchingClient, DataFetchingClientProvider } from 'data-fetching-client';
import { initializePortal, getLocaleInfo as getPortalsLocaleInfo } from 'portals-platform-lib';
import { FloatingAlertList } from 'foundations-components/transitional/components/FloatingAlertList';
import { Routes } from './components/Routes';
import { AuthWrapper } from './containers/AuthWrapper';
import { AppLayout } from './components/layouts/AppLayout';
import { store } from './redux/store';
import { Metrics } from './utils/Metrics';
import { PortalsPlatformDataProvider } from './hooks/usePortalPlatformData';
import { ErrorActions } from './constants/ErrorActions';
import { getPreviewState } from './utils/getPreviewState';
import { previewStateCaptured } from './features/PreviewSlice/PreviewSlice';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const client = new DataFetchingClient({
  onFetcherRejection: (reason, operationInfo) => {
    Metrics.counter('dfc-fetch-error', {
      operation: operationInfo.fieldName
    }).increment();
    Raven.captureMessage(`DFC ${operationInfo.operationType} error: ${operationInfo.fieldName}`, {
      extra: {
        variables: operationInfo.variables,
        reason
      }
    });
  }
});
export const getLocaleInfo = () => getPortalsLocaleInfo({
  client
});
export const prepareApp = async () => {
  const previewState = getPreviewState();
  store.dispatch(previewStateCaptured({
    isPreview: previewState.isPreview,
    previewJwt: previewState.previewJwt
  }));
  let portalData = null;
  const startTime = performance.now();
  try {
    const result = await initializePortal({
      client
    });
    portalData = result.portalData;
    Metrics.timer('initialize-portal-duration').update(performance.now() - startTime);
    Metrics.counter('initialize-portal-success').increment();
  } catch (error) {
    Metrics.timer('initialize-portal-duration').update(performance.now() - startTime);
    Metrics.counter('initialize-portal-failure').increment();
    Raven.captureException(error instanceof Error ? error : new Error(String(error)), {
      tags: {
        action: ErrorActions.INITIALIZE_PORTAL
      }
    });
    console.error('Failed to fetch portal data:', error);
  }
  return {
    props: {
      dataFetchingClient: client,
      portalData
    }
  };
};
export function AppComponent({
  dataFetchingClient,
  portalData
}) {
  return /*#__PURE__*/_jsx(DataFetchingClientProvider, {
    client: dataFetchingClient,
    children: /*#__PURE__*/_jsx(Provider, {
      store: store,
      children: /*#__PURE__*/_jsx(PortalsPlatformDataProvider, {
        portalData: portalData,
        children: /*#__PURE__*/_jsxs(AuthWrapper, {
          children: [/*#__PURE__*/_jsx(FloatingAlertList, {}), /*#__PURE__*/_jsx(AppLayout, {
            children: /*#__PURE__*/_jsx(Routes, {})
          })]
        })
      })
    })
  });
}